import { useQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import { MyUploadFile } from "./types";
import { GET_ATTACHMENT_FILES } from "../api/get-attachment-filtes";

export function useFileList({ value }: { value?: string[] }) {
  const [fileList, setFileList] = useState<MyUploadFile[]>([]);

  const skip = !Array.isArray(value) || value?.length === 0;

  const { data } = useQuery(GET_ATTACHMENT_FILES, {
    variables: {
      fileIds: value ?? [],
    },
    skip,
  });

  useEffect(() => {
    setFileList(
      data?.file.map((file) => ({
        uid: file.id,
        name: file.fileName,
        response: {
          fileId: file.id,
          name: file.fileName,
          link: file.link,
        },
      })) ?? [],
    );
  }, [data]);

  return {
    fileList,
    setFileList,
  };
}
